import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
  name: 'project',
  initialState: {
    projects: [],
    milestones: [],
    resources: [],
    statusUpdates: [],
    selectedProject: null,
    selectedMilestone: null,
    selectedResource: null,
    isLoading: false,
    error: null,
    stats: {
      totalProjects: 0,
      onTrack: 0,
      atRisk: 0,
      critical: 0,
    },
  },
  reducers: {
    setProjects(state, action) {
      state.projects = action.payload;
    },
    setMilestones(state, action) {
      state.milestones = action.payload;
    },
    setResources(state, action) {
      state.resources = action.payload;
    },
    setStatusUpdates(state, action) {
      state.statusUpdates = action.payload;
    },
    setSelectedProject(state, action) {
      state.selectedProject = action.payload;
    },
    setSelectedMilestone(state, action) {
      state.selectedMilestone = action.payload;
    },
    setSelectedResource(state, action) {
      state.selectedResource = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStats(state, action) {
      state.stats = { ...state.stats, ...action.payload };
    },
    addProject(state, action) {
      state.projects.push(action.payload);
    },
    updateProject(state, action) {
      const index = state.projects.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.projects[index] = action.payload;
      }
    },
    removeProject(state, action) {
      state.projects = state.projects.filter(p => p.id !== action.payload);
    },
    addMilestone(state, action) {
      state.milestones.push(action.payload);
    },
    updateMilestone(state, action) {
      const index = state.milestones.findIndex(m => m.id === action.payload.id);
      if (index !== -1) {
        state.milestones[index] = action.payload;
      }
    },
    removeMilestone(state, action) {
      state.milestones = state.milestones.filter(m => m.id !== action.payload);
    },
    addResource(state, action) {
      state.resources.push(action.payload);
    },
    updateResource(state, action) {
      const index = state.resources.findIndex(r => r.id === action.payload.id);
      if (index !== -1) {
        state.resources[index] = action.payload;
      }
    },
    removeResource(state, action) {
      state.resources = state.resources.filter(r => r.id !== action.payload);
    },
    clearProjectState(state) {
      state.projects = [];
      state.milestones = [];
      state.resources = [];
      state.statusUpdates = [];
      state.selectedProject = null;
      state.selectedMilestone = null;
      state.selectedResource = null;
      state.error = null;
    },
  },
});

export const projectActions = projectSlice.actions;

export default projectSlice;

